// HeroBanner.tsx
import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Container, Typography, Breadcrumbs, Link, Box, useMediaQuery } from '@mui/material';
import { aboutusbanner, mainbanner } from '../../assets';

gsap.registerPlugin(ScrollTrigger);

const HeroBanner: React.FC = () => {
    const isMobile = useMediaQuery("(max-width: 600px)");
    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#hero-banner",
                start: "top top",
                end: "bottom top",
                scrub: true,
            },
        });

        document.querySelectorAll(".parallax").forEach((layer) => {
            const depth = parseFloat((layer as HTMLElement).dataset.depth || "0");
            const movement = -(window.innerHeight * depth);
            tl.to(layer, { y: movement, ease: "none" }, 0);
        });

        return () => ScrollTrigger.getAll().forEach((t) => t.kill());
    }, []);

    return (
        <Box id="hero-banner" sx={{ position: "relative", width: "100%", height: isMobile ? "38vh":"60vh", overflow: "hidden", backgroundColor: "rgb(14, 14, 14)" }}>
            {/* Background Layer */}
            <Box
                className="parallax"
                data-depth="0.21"
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url(${mainbanner})`,
                    backgroundSize: "cover",    
                    backgroundPosition: "center",
                    height: isMobile ? "40vh" : "68vh",
                    // based on the design, the width should be 100% 
                    width: "100%",
                }}
            />

            {/* Overlay */}
            <Box sx={{ position: "absolute", inset: 0, backgroundColor: "rgba(0, 0, 0, 0.5)" }}></Box>

            {/* Content */}
            <Container
                sx={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    height: "100%",
                    color: "white",
                    zIndex: 1,
                    marginLeft: { xs: 0, sm: 10 },
                }}
            >
                 <Typography variant="h1" align="center" sx={{ fontWeight: "600", fontSize: { xs: "2.5rem", sm: "3.5rem" } , color: "white"}}>
                    Contact Us
                </Typography>
                <Breadcrumbs aria-label="breadcrumb" sx={{ color: "white", marginBottom: 2 }}>
                {/* home as little greay okay  */}
                    <Link href="/" color="inherit" sx={{ textDecoration: "none", fontWeight: "600", color: "#ccc", fontFamily: "LEMON MILK", }}>
                        Home
                    </Link>
                    <Typography color="inherit" sx={{ fontWeight: "600", color: "white" , textDecoration: "none", fontFamily: "LEMON MILK",}}>
                        Contact Us
                    </Typography>
                </Breadcrumbs>
               
            </Container>

        </Box>
    );
};

export default HeroBanner;
